<div class="modal-header" [ngClass]="
    this.schoolProps.properties.job_only_school == true ? '' : ''
  ">
  <!-- <h5 class="modal-title" id="exampleModalLabel">Booking Confirmation</h5> -->
  <button type="button" tabindex="0" class="btn-close b-wcag" (click)="bsModalRef.hide()" aria-label="Close"></button>
</div>
<div class="modal-body" [ngClass]="
    this.schoolProps.properties.job_only_school == true ? '' : ''
  " id="printArea">
  <div class="row">
    <div class="col-md-9 col-sm-8 col-lg-9">
      <div class="col-md-12 col-lg-12 d-flex align-items-center">
        <div class="pic-and-check ml-0">
          <img alt="" [src]="
              teacher.meta.profile_image != null
                ? teacher.meta.profile_image
                : '../../../../assets/images/teacher-static-profile.png'
            " class="profile-picture img-complete-match" />
        </div>

        <div class="pic-and-check ml-10">
          <div class="d-flex">
            <h1 class="user-title">
              {{ teacher?.user.full_name }}
            </h1>
            <span>
              <app-validated-dict [validateDict]="teacher.validated_dict">
              </app-validated-dict>
            </span>
          </div>
          <h6 class="user-sub-title mb-0">{{ teacher.meta.you_are_a }}</h6>
          <p>
            <span class="grey-3 fs-12">Teacher status</span>
            <span *ngIf="teacher.meta.status" class="user-sub-title ml-2">
              {{ teacher.meta.status }}</span>
          </p>
          <ul class="custom fs-12" *ngIf="schoolProps.properties.role != 'My Bookings'">
            <li *ngIf="teacher.location != ''">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                  class="bi bi-geo-alt clr-grey-7" viewBox="0 0 16 16">
                  <path
                    d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                  <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                </svg>
                {{ teacher.location }}</span>
              <span *ngIf="this.from != 'headhunter' && this.from != 'f_n_t'" class="divider-right ml-5 mr-5"></span>
            </li>

            <li *ngIf="this.from != 'headhunter' && this.from != 'f_n_t'">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="currentColor"
                  class="bi bi-telephone clr-grey-7" viewBox="0 0 16 16">
                  <path
                    d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                </svg>
                {{ teacher.phone }}</span>
            </li>
          </ul>
          <ul class="custom fs-12">
            <li *ngIf="teacher.accreditation.accreditation">
              <span>Accreditation No </span>
              <span *ngIf="teacher.accreditation.accreditation.length > 0">
                {{ teacher.accreditation.accreditation[0].accreditation_id }}
              </span>
              <span class="divider-right ml-5 mr-5"></span>
            </li>
            <li *ngIf="this.from != 'headhunter' && this.from != 'f_n_t'">
              <ng-container
                *ngIf="(schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer') && schoolProps.properties.role_code != 'AT'">
                <span class="grey-3 fs-12">Employee ID</span> <span>
                  {{teacher?.user_data?.qld_data?.employee_id}}</span>
                <span *ngIf="schoolProps.properties.role != 'My Bookings'" class="divider-right ml-5 mr-5"></span>
              </ng-container>
              <ng-container *ngIf="schoolProps.properties.role != 'My Bookings'">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                  class="bi bi-envelope clr-grey-7" viewBox="0 0 16 16">
                  <path
                    d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                </svg>
                <span class="ms-1">{{ teacher.user.email }}</span>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="col-lg-6" *ngIf="this.schoolProps.properties.job_only_school == false">
            <div class="stats mt-15">                
               <h5 class="text-regular-bold c-p fit-content mb-5  clr-cc-vilot">Booking stats</h5>
               <div class="d-flex" style="justify-content: space-between;">
                  <div class="">
                     <strong>
                        <p class="text-regular-bold fs-22">{{teacher?.stat?.booking_response}}%</p>
                     </strong>
                     <p class="fs-16 clr-grey-2">Booking response<i class="bi bi-info-circle ml-4 clr-cc-vilot text-regular-bold" triggers="mouseenter:mouseleave" popover="{{ 'This indicates how often a teacher responds to booking requests. A higher response rate indicates a more engaged teacher.'}}"></i></p>             
                  </div>
                  <div class="">
                    <strong>
                       <p class="text-regular-bold fs-22">{{teacher?.stat?.avail_update_count}}%</p>
                    </strong>
                    <p class="fs-16 clr-grey-2">Availablity updated<i class="bi bi-info-circle ml-4 clr-cc-vilot" triggers="mouseenter:mouseleave" popover="{{'This indicates how many upcoming days a teacher has their availability updated for. A higher rate indicates more days updated.'}}"></i></p>
                 </div>
                 <div class="">
                    <strong>
                       <p class="text-regular-bold fs-22">{{teacher?.stat?.last_login}}</p>
                    </strong>
                    <p class="fs-16 clr-grey-2">Last seen<i class="bi bi-info-circle ml-4 clr-cc-vilot" triggers="mouseenter:mouseleave" popover="{{'This indicates the last time a teacher was on the ClassCover app.'}}"></i></p>
                 </div>
               </div>
            </div>
         </div> -->
    <div class="col-md-3 col-sm-4 col-lg-3">
      <div class="d-flex justify-content-right align-items-center mt-10">
        <div *ngIf="this.from == 'headhunter'">
          <p (click)="openInviteModal(teacher)" [ngClass]="remainingInvites == '0' ? 'input-cursor-na' : ''"
            *ngIf="this.invite_sent == false" class="c-p clr-cc-vilot text_medium">
            <i class="bi bi-send-fill"></i> Invite to job
          </p>
          <p *ngIf="this.invite_sent == true" class="c-p clr-green text_medium">
            <i class="bi bi-check2"></i> Invite sent
          </p>
        </div>
        <a class="btn print_btn ms-2" (click)="printSection()">Print</a>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-lg-12 col-sm-12  mt-10">
    <div class="availability-legends text-regular-medium">
      <div class="legend-item">
        <span class="legend-circle available"></span>
        <span class="legend-label">Available</span>
      </div>
      <div class="legend-item">
        <span class="legend-circle havent-indicated"></span>
        <span class="legend-label">Haven’t Indicated</span>
      </div>
      @if(schoolProps.properties.is_qld_school){
        <div class="legend-item">
          <span class="legend-circle booked-parent"></span>
          <span class="legend-label">Booked</span>
        </div>
      }@else {
        <div class="legend-item">
          <span class="legend-circle booked"></span>
          <span class="legend-label">Booked</span>
        </div>
      }
      <div class="legend-item">
        <span class="legend-circle booked-elsewhere"></span>
        <span class="legend-label">Booked Elsewhere</span>
      </div>
      <div class="legend-item">
        <span class="legend-circle unavailable"></span>
        <span class="legend-label">Unavailable</span>
      </div>
      @if(schoolProps.properties.is_qld_school){
      <div class="legend-item">
        <span class="legend-circle LRT"></span>
        <span class="legend-label">LRT</span>
      </div>
      <div class="legend-item">
        <span class="legend-circle DRT"></span>
        <span class="legend-label">DRT</span>
      </div>
      }
    </div>
    <!-- <div class="justify-content-space-bet availability-legends">
                    <div class="text-legend align-items-center d-flex">
                        <div class="user-sub-title available-color mr-5"></div>
                        <div class="txt-regular">Available</div>
                    </div>
                    <div class="text-legend align-items-center d-flex ml-5">
                        <div class="havent-indicated user-sub-title mr-5"></div>
                        <div class="txt-regular">Haven’t Indicated</div>
                    </div>
                    <div class="text-legend align-items-center d-flex ml-5">
                        <div class="booked user-sub-title mr-5"></div>
                        <div class="txt-regular">Booked</div>
                    </div>
                    <div class="text-legend align-items-center d-flex ml-5">
                        <div class="booked-elsewhere user-sub-title mr-5"></div>
                        <div class="txt-regular">Booked Elsewhere</div>
                    </div>
                    <div class="text-legend align-items-center d-flex ml-5">
                        <div class="unavailable user-sub-title mr-5"></div>
                        <div class="txt-regular">Unavailable</div>
                    </div>
                </div> -->
  </div>
  <div class="row" *ngIf="this.schoolProps.properties.job_only_school == false">
    <div class="col-md-12 col-lg-12 mt-20">
      <app-inline-calendar [isVisiblePrintStatus]="showPrintStatus" [from]="from" [teacherID]="teacher.id" [school_id]="school_id"
        [availability]="teacher.availability" (onDatePicked)="setArrData($event)">
      </app-inline-calendar>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-lg-12 mt-20">
      <nav>
        <div class="nav nav-tabs profilePopUpTab" id="nav-tab" role="tablist">
          @if(schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer'){
          <button tabindex="0"
            [class.active]="this.schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer'"
            *ngIf="teacher?.user_data?.show_qld" class="nav-link" id="nav-qld-tab" data-bs-toggle="tab"
            data-bs-target="#nav-qld" type="button" role="tab" aria-controls="nav-qld" aria-selected="false">
            Queensland Department of Education
          </button>
          }
          <button tabindex="0" class="nav-link"
            [class.active]="!this.schoolProps.properties.is_qld_school &&  schoolProps.properties.user_type != 'Tracer'"
            id="nav-video-introduction-tab" data-bs-toggle="tab" data-bs-target="#nav-video-introduction" type="button"
            role="tab" aria-controls="nav-video-introduction" aria-selected="true">
            Video Introduction
          </button>
          @if(!schoolProps.properties.is_qld_school && schoolProps.properties.user_type != 'Tracer'){
          <button tabindex="0" class="nav-link" id="nav-sub-tab" data-bs-toggle="tab" data-bs-target="#nav-sub"
            type="button" role="tab" aria-controls="nav-sub" aria-selected="true">
            Subjects & Levels
          </button>
          }
          <button tabindex="0" class="nav-link" id="nav-exp-tab" data-bs-toggle="tab" data-bs-target="#nav-exp"
            type="button" role="tab" aria-controls="nav-exp" aria-selected="false">
            Experience
          </button>
          <button tabindex="0" class="nav-link" id="nav-qual-tab" data-bs-toggle="tab" data-bs-target="#nav-qual"
            type="button" role="tab" aria-controls="nav-qual" aria-selected="false">
            Qualifications
          </button>
          <button tabindex="0" class="nav-link" id="nav-attach-tab" data-bs-toggle="tab" data-bs-target="#nav-attach"
            type="button" role="tab" aria-controls="nav-attach" aria-selected="false">
            Attachments
          </button>
          <button tabindex="0" class="nav-link" id="nav-ref-tab" data-bs-toggle="tab" data-bs-target="#nav-ref"
            type="button" role="tab" aria-controls="nav-ref" aria-selected="false">
            References
          </button>
          <button tabindex="0" *ngIf="teacher?.bce_data?.is_bce" class="nav-link" id="nav-bce-tab" data-bs-toggle="tab"
            data-bs-target="#nav-bce" type="button" role="tab" aria-controls="nav-bce" aria-selected="false">
            BCE Questionnaire
          </button>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade"
          [class.show]="!this.schoolProps.properties.is_qld_school &&  schoolProps.properties.user_type != 'Tracer'"
          [class.active]="!this.schoolProps.properties.is_qld_school &&  schoolProps.properties.user_type != 'Tracer'"
          id="nav-video-introduction" role="tabpanel" aria-labelledby="nav-video-introduction-tab">
          <ng-container *ngIf="introVideo?.id; else addVideoPrompt">
            <div class="row justify-content-center align-items-center text-center p-20 mt-20">
              <div class="col-lg-12">
                <app-video-player [videoMeta]="introVideo"></app-video-player>
              </div>
            </div>
          </ng-container>
          <ng-template #addVideoPrompt>
            <p class="mt-20"> No introduction video added.</p>
          </ng-template>
        </div>
        <div class="tab-pane fade" id="nav-sub" role="tabpanel" aria-labelledby="nav-sub-tab">
          <div class="col-md-12 col-lg-12 mt-5 profile__popup">
            <div class="row">
              <div class="col-md-12 mt-8">
                <h1 class="user-title">Subjects qualified to teach</h1>
              </div>
              <div class="col-md-12" *ngIf="teacher.meta.tags">
                <ul class="custom-li-tag">
                  @if(teacher.meta.tags.length > 0){
                  <li *ngFor="let tag of teacher.meta.tags">
                    <span class="qualified-in bg-tags">{{ tag }}</span>
                  </li>
                  }@else{
                  <li class="txt-regular tags mt-5">No Subjects found</li>
                  }
                </ul>
              </div>
              <div class="col-md-12" *ngIf="!teacher.meta.tags">
                <p class="txt-regular tags mt-5">No Subjects found</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h1 class="user-title mt-8">Levels</h1>
              </div>
              <div class="col-md-12" *ngIf="teacher.meta.experiance_tree">
                <ul class="custom-li-tag">
                  @if(teacher.meta.experiance_tree.length > 0){
                  <li *ngFor="let levels of teacher.meta.experiance_tree">
                    <span class="levels bg-tags">{{ levels }}</span>
                  </li>
                  } @else{
                  <li class="txt-regular tags mt-5">No levels found</li>
                  }
                </ul>
              </div>
              <div class="col-md-12" *ngIf="!teacher.meta.experiance_tree">
                <p class="txt-regular tags mt-5">No levels found</p>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-exp" role="tabpanel" aria-labelledby="nav-exp-tab">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">Employment Summary</p>
                <div class="" *ngIf="teacher.meta.experience_description">
                  <p class="txt-regular mt-5" *ngIf="teacher.meta.experience_description.length > 0">
                    {{ teacher.meta.experience_description }}
                  </p>
                  <p class="txt-regular mt-5" *ngIf="teacher.meta.experience_description.length == 0">
                    No employment summary found
                  </p>
                </div>
                <div class="" *ngIf="!teacher.meta.experience_description">
                  <p class="txt-regular mt-5">No employment summary found</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">Experience</p>
                <div class="" *ngIf="teacher.work_experience.work_experience">
                  <div *ngIf="teacher.work_experience.work_experience.length > 0">
                    <div class="" *ngFor="
                        let work_experience of teacher.work_experience
                          .work_experience
                      ">
                      <p class="user-title mt-10">
                        {{ work_experience.school_name }}
                      </p>
                      <p class="user-sub-title mt-5">
                        {{ work_experience.job_title
                        }}<span class="divider-right ml-5 mr-5"></span>{{ work_experience.from_date }}
                        -
                        {{ work_experience.to_date }}
                      </p>
                      <p class="txt-regular mt-5">
                        {{ work_experience.experience_summary }}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p class="txt-regular mt-5" *ngIf="
                        teacher.work_experience.work_experience.length == 0
                      ">
                      No experience found
                    </p>
                  </div>
                </div>
                <div class="" *ngIf="!teacher.work_experience.work_experience">
                  <p class="txt-regular mt-5">No experience found</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-qual" role="tabpanel" aria-labelledby="nav-qual-tab">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">Qualifications</p>
              </div>
            </div>

            <div class="" *ngIf="teacher.meta.qualifications_v2">
              <div class="qualification-modal-table mt-15" *ngIf="teacher.meta.qualifications_v2.length > 0">
                <table>
                  <tr class="text-r-m-16 table-header">
                    <th>Title</th>
                    <th>Institution</th>
                    <th>Type</th>
                    <th>Actions</th>
                  </tr>
                  <tr class="txt-regular" *ngFor="
                      let qualifications of teacher.meta.qualifications_v2
                    ">
                    <td>{{ qualifications.title }}</td>
                    <td>{{ qualifications.institution }}</td>
                    <td>{{ qualifications.type }}</td>
                    <td class="text_medium clr-cc-vilot" *ngIf="qualifications.file">
                      <a *ngIf="qualifications.file.length > 0" class="clr-cc-vilot"
                        href="{{ qualifications.file }}">Download</a>
                    </td>

                    <td class="clr-cc-vilot" *ngIf="!qualifications.file"></td>
                  </tr>
                </table>
              </div>
              <p class="txt-regular mt-5" *ngIf="teacher.meta.qualifications_v2.length == 0">
                No qualification found
              </p>
            </div>
            <div class="" *ngIf="!teacher.meta.qualifications_v2">
              <p class="txt-regular mt-5">No qualification found</p>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-attach" role="tabpanel" aria-labelledby="nav-attach-tab">
          <div *ngIf="this.from != 'headhunter'">
            <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">Attachments</p>
              </div>
            </div>
            <div class="" *ngIf="teacher.meta.attachment_files">
              <div class="qualification-modal-table mt-15" *ngIf="teacher.meta.attachment_files.length > 0">
                <table>
                  <tr class="text-r-m-16 table-header">
                    <th>Title</th>
                    <th>Description</th>
                    <th>Actions</th>
                  </tr>
                  <tr class="txt-regular" *ngFor="
                      let attachment_files of teacher.meta.attachment_files
                    ">
                    <td>{{ attachment_files.name }}</td>
                    <td>{{ attachment_files.description }}</td>
                    <td class="text_medium" *ngIf="attachment_files.file">
                      <a class="clr-cc-vilot" *ngIf="attachment_files.file.length > 0"
                        href="{{ attachment_files.file }}">Download certificate</a>
                    </td>
                    <td class="clr-cc-vilot" *ngIf="!attachment_files.file"></td>
                  </tr>
                </table>
              </div>
              <p class="txt-regular mt-5" *ngIf="teacher.meta.attachment_files.length == 0">
                No attachments found
              </p>
            </div>
            <div class="" *ngIf="!teacher.meta.attachment_files">
              <p class="txt-regular mt-5">No attachments found</p>
            </div>
          </div>
          <div *ngIf="this.from == 'headhunter'">
            <p class="text-center mt-30">
              <img class="no-invite-image" src="assets/images/NoResultFound/hideOnHead.png" alt="No invites found!" />
            </p>
            <h5 class="title text-center mt-15">
              Attachments and CV's are only shown if a potential candidate
              applies for the job.
            </h5>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-ref" role="tabpanel" aria-labelledby="nav-ref-tab">
          <div *ngIf="this.from != 'headhunter'">
            <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">References</p>
              </div>
            </div>

            <div class="" *ngIf="teacher.meta.references">
              <div class="qualification-modal-table mt-15" *ngIf="teacher.meta.references.length > 0">
                <table>
                  <tr class="text-r-m-16 table-header">
                    <th>Name</th>
                    <th>Phone No</th>
                    <th>Email</th>
                  </tr>
                  <tr class="txt-regular" *ngFor="let reference of teacher.meta.references">
                    <td>{{ reference.name }} <br />{{ reference.org }}</td>
                    <td>{{ reference.phone }}</td>
                    <td>{{ reference.email }}</td>
                  </tr>
                </table>
              </div>
              <p class="txt-regular mt-5" *ngIf="teacher.meta.references.length == 0">
                No reference found
              </p>
            </div>
            <div class="" *ngIf="!teacher.meta.references">
              <p class="txt-regular mt-5">No reference found</p>
            </div>
          </div>
          <div *ngIf="this.from == 'headhunter'">
            <p class="text-center mt-30">
              <img class="no-invite-image text-center" src="assets/images/NoResultFound/hideOnHead.png"
                alt="No invites found!" />
            </p>
            <h5 class="title text-center mt-15">
              References are only shown if potential candidate applies for the
              job.
            </h5>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-bce" role="tabpanel" aria-labelledby="nav-bce-tab">
          <div *ngIf="this.from != 'headhunter'">
            <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">BCE Questionnaire</p>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="accordion" id="accordion-sec" *ngIf="teacher.bce_data.bce_info">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed user-title" type="button" data-bs-toggle="collapse"
                        data-bs-target="#mandatoryCollapse" aria-expanded="false" aria-controls="mandatoryCollapse">
                        Mandatory questions
                      </button>
                    </h2>
                    <div id="mandatoryCollapse" class="accordion-collapse collapse" aria-labelledby="headingOne"
                      data-bs-parent="#accordion-sec">
                      <div class="accordion-body">
                        <p>
                          Location preferences:
                          <span>{{
                            teacher.bce_data.bce_info.meta.prefered_location
                            }}</span>
                        </p>
                        <ul class="listStyleNone" *ngIf="
                            teacher.bce_data.bce_info.meta.card_type ===
                            'blueCard'
                          ">
                          <li class="fs-14 txt-regular">
                            Blue Card Number:
                            <b>{{ teacher.bce_data.bce_info.blue_card_id }}</b>
                          </li>

                          <li class="fs-14 txt-regular">
                            Type of Blue Card:

                            <b>{{
                              teacher.bce_data.bce_info.meta?.blue_card_type
                              }}</b>
                          </li>

                          <li class="fs-14 txt-regular">
                            Blue Card holder's name:
                            <b>{{
                              teacher.bce_data.bce_info.meta.card_holder_name
                              }}</b>
                          </li>

                          <li class="fs-14 txt-regular">
                            Expiry Date:
                            <b>{{
                              teacher.bce_data.bce_info.meta.expiry_date
                              }}</b>
                          </li>
                        </ul>
                        <p *ngIf="
                            teacher.bce_data.bce_info.meta.card_type === 'QCT'
                          ">
                          QCT number:
                          <span>{{ teacher.bce_data.bce_info.qct_id }}</span>
                        </p>
                        <p>
                          Personal email:
                          <span>{{
                            teacher.bce_data.bce_info.meta.personal_email
                            }}</span>
                        </p>
                        <p>
                          Right to work:
                          <span>{{
                            teacher.bce_data.bce_info.meta.right_to_work
                            }}</span>
                        </p>
                        <p>
                          CV:
                          <a href="{{ teacher.bce_data.bce_info.file }}" target="_blank">{{
                            teacher.bce_data.bce_info.file }}</a>
                        </p>
                        <p>
                          What interests you about working for BCE:
                          <span>{{
                            teacher.bce_data.bce_info.meta.about_interest
                            }}</span>
                        </p>
                        <p>
                          What roles are you interested in:
                          <span>{{
                            teacher.bce_data.bce_info.meta.bce_roles
                            }}</span>
                        </p>
                        <p>
                          Interested in:
                          <span>{{
                            teacher.bce_data.bce_info.meta.interested_role
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed user-title" type="button" data-bs-toggle="collapse"
                        data-bs-target="#safeguardingCollapse" aria-expanded="false"
                        aria-controls="safeguardingCollapse">
                        Safeguarding questions
                      </button>
                    </h2>
                    <div id="safeguardingCollapse" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                      data-bs-parent="#accordion-sec">
                      <div class="accordion-body">
                        <p>
                          Have you been issued a negative notice (Blue card)?:
                          <span>{{
                            teacher.bce_data.bce_info.meta.negative_notice
                            }}</span>
                        </p>
                        <p>
                          Have you ever had your QCT registration or Blue Card
                          suspended?:
                          <span>{{
                            teacher.bce_data.bce_info.meta
                            .suspended_registration
                            }}</span>
                        </p>
                        <p>
                          Have you ever abused, exploited or neglected a child
                          or vulnerable adult?:
                          <span>{{
                            teacher.bce_data.bce_info.meta.abused
                            }}</span>
                        </p>
                        <p>
                          Have you ever been accused of offences relating to a
                          child or vulnerable adult?:
                          <span>{{
                            teacher.bce_data.bce_info.meta.accused
                            }}</span>
                        </p>
                        <p>
                          Have you ever been the subject of a substantiated
                          complaint, or convicted of an offence relating to a
                          child or vulnerable adult?:
                          <span>{{
                            teacher.bce_data.bce_info.meta.substantiated
                            }}</span>
                        </p>
                        <p>
                          Are you currently the subject of a criminal legal
                          proceeding, including police charges, for an offence
                          relating to a child or vulnerable adult?:
                          <span>{{
                            teacher.bce_data.bce_info.meta.criminal
                            }}</span>
                        </p>
                        <p>
                          Are the responses you have provided to these questions
                          true and correct?:
                          <span>{{
                            teacher.bce_data.bce_info.meta.all_questions
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed user-title" type="button" data-bs-toggle="collapse"
                        data-bs-target="#multipleCollapse" aria-expanded="false" aria-controls="multipleCollapse">
                        Multiple choice questions
                      </button>
                    </h2>
                    <div id="multipleCollapse" class="accordion-collapse collapse" aria-labelledby="headingThree"
                      data-bs-parent="#accordion-sec">
                      <div class="accordion-body">
                        <p>
                          Teaching levels:
                          <span>{{
                            teacher.bce_data.bce_info.meta.teachingLevels
                            }}</span>
                        </p>
                        <p>
                          Subjects:
                          <span>{{
                            teacher.bce_data.bce_info.meta.subject
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="txt-regular mt-5" *ngIf="!teacher.bce_data.bce_info">
                  No bce questionnaire found
                </p>
              </div>
            </div>
            <div class="" *ngIf="">
              <p class="txt-regular mt-5">No bce questionnaire found</p>
            </div>
          </div>
        </div>
        <div class="tab-pane fade"
          [class.show]="this.schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer'"
          *ngIf="teacher?.user_data?.show_qld"
          [class.active]="this.schoolProps.properties.is_qld_school || schoolProps.properties.user_type == 'Tracer'"
          id="nav-qld" role="tabpanel" aria-labelledby="nav-qld-tab">
          <div *ngIf="this.from != 'headhunter'">
            <!-- <div class="row">
              <div class="col-md-12 mt-15">
                <p class="user-title">BCE Questionnaire</p>
              </div>
            </div> -->
            <div class="row mt-3">
              <div class="col-md-12">
                <app-qld-profile-completion [from]="'qld-modal'" [profileData]="teacher"></app-qld-profile-completion>
                <!-- <div class="accordion" id="accordion-sec" *ngIf="teacher.qld_data.qld_info">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed user-title" type="button" data-bs-toggle="collapse"
                        data-bs-target="#mandatoryCollapse" aria-expanded="false" aria-controls="mandatoryCollapse">
                        Mandatory questions
                      </button>
                    </h2>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #resendPendingInviteModal>
    <form [formGroup]="inviteToJobForm" [ngClass]="
      this.schoolProps.properties.job_only_school == true
        ? ''
        : ''
    ">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalLabel">
          Send a custom message with your job invite (optional)
        </h4>
        <button type="button" (click)="this.bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
      </div>

      <div class="modal-body pb-0">
        <div class="row align-items-center">
          <div class="col-md-12">
            <p class="text_medium">
              You can add a custom message or provide additional context to your
              invite
            </p>
          </div>
          <div class="col-md-12 mt-5">
            <textarea class="form-control" placeholder="Type here" formControlName="custom_message" rows="3"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-10">
        <button (click)="inviteToJob(Invitedteacher)" type="button" class="btn cc_p_btn f_c fs_13">
          Send invite
        </button>
      </div>
    </form>
  </ng-template>